import studentCopy from "@shared/student_copy.json";

export const ONLINE_READING_MESSAGE = studentCopy.status.readingOnlineComingSoon;
export const CONTENT_NOT_AVAILABLE_MESSAGE = studentCopy.status.readingOnlineComingSoon;
export const PREMIUM_ROUTE = "/student/premium";
